<!--
 * @Description: v2.1.5班组记账页面
-->
<template>
  <div class="page">
    <div class="button">
      <div class="totalmonth" style="height:34px;line-height:32px">
        <span class="total"> 当月统计</span>
        <span class="totaltime">{{ year + "-" + month }}</span>
      </div>
      <div class="totalmonth" style="font-weight:400">
        <span class="total" style="font-size:14px;color:#000;line-height:34px;margin-right:14px"> 当前项目：</span>
        <el-select v-model="projectName" placeholder="暂无项目" @change="getProjectName" style="display:inline-block;width:150px;height:34px">
            <el-option v-for="(item,i) in projectlist" :key="i" :label="item.projectName" :value="item.no">
            </el-option>
        </el-select>
      </div>
      <div>
        <span class="totalmoney">总收入：</span>
        <span class="totalincome">+{{ totalincome.toFixed(2) }}</span>
      </div>
      <div class="line"></div>
      <div class="line-right">
        <span class="totalmoney">总支出：</span>
        <span class="totalexpenses">-{{ totalexpenses.toFixed(2) }}</span>
      </div>
      <!-- 记收入/支出 -->
      <AddIncomeExpenses
        :billType="index + 1"
        ref="editincome"
        @close="getprojectlist()"
        :class="[index + 1 == 1 ? 'recoderincome' : 'recoderexpenses']"
        v-for="(item, index) in 2"
        :key="index"
        :project="projectlist[projectid]"
        :projectlist="projectlist"
        :projectName="projectName" 
        :projectNo="projectNo"
        @editend="getprojectlist"
      ></AddIncomeExpenses>
      <!-- 项目管理 -->
      <projectManagement ref="projectManagement" isBzjz @change="getprojectlist()" @upNo="upNo"></projectManagement>
      <!-- 工友管理 -->
      <WorkerManagement  ref="wordkrManagement" isBzjz  @close='getprojectlist()' @upNo="upNo"></WorkerManagement>
    </div>
    <div class="teamrecord">
      <div class="aside">
        <div @click="isshow = !isshow" class="yearselect">
          <span>{{ year }}年</span>
          <span class="expand"
            ><img src="@/assets/record/expand.png" alt=""
          /></span>
        </div>
        <template v-if="isshow">
          <div class="yearoption">
            <div
              v-for="(item, index) in yearoption"
              :key="index"
              class="itemyear"
              @click="changeyear(item)"
            >
              {{ item + "年" }}
            </div>
          </div>
        </template>
        <div
          v-for="(item, index) in 12"
          :key="index"
          :class="[
            { month: true },
            month == index + 1 ? 'selectedmonth' : 'month'
          ]"
          @click="changemonth(index)"
        >
          <span>{{ item }}</span>
          <span class="monthunit">{{ `&nbsp;` }}月</span>
        </div>
      </div>
      <div class="content">
        <div class="content-nav">
          <div class="nav-time">时间</div>
          <div class="nav-income">收入</div>
          <div class="nav-income mar-20">支出</div>
          <div class="nav-note">备注</div>
          <div>操作</div>
        </div>
        <div class="list-item" v-if="list.length>0">
          <div v-for="(item, index) in list" :key="index">
            <div class="item-title">
              <div class="title-date">
                <span class="day">{{ item.recordDate | getdate }}</span>
                <span class="title-time">{{ `&nbsp;` }}/{{ `&nbsp;` }}</span>
                <span class="title-time">{{ item.recordDate | getmonth }}</span>
                <span class="title-time">{{ `&nbsp;` }}/{{ `&nbsp;` }}</span>
                <span class="title-time">{{ item.recordDate | getyear }}</span>
              </div>
              <div class="title-income">{{ "+" + item.income.toFixed(2) }}</div>
              <div class="title-expenses">
                {{ "-" + item.expenses.toFixed(2) }}
              </div>
            </div>
            <div
              v-for="seconde in item.settleBillVoList"
              :key="seconde.no"
              class="item-content"
            >
              <div class="item-img">
                <img :src="getimg(seconde.billCostName)" alt="" />
              </div>
              <template v-if="seconde.billType == 2">
              <div class="item-name" v-if="seconde.settleWorkerList&&seconde.settleWorkerList.length>1">{{ seconde.billCostName }}-{{seconde.settleWorkerList[0].name}}等{{seconde.settleWorkerList.length}}人</div>
              <div class="item-name" v-if="seconde.settleWorkerList&&seconde.settleWorkerList.length==1">{{ seconde.billCostName }}-{{seconde.settleWorkerList[0].name}}</div>
              <div class="item-name" v-if="seconde.settleWorkerList&&seconde.settleWorkerList.length==0">{{ seconde.billCostName}}</div>
              <div class="item-name" v-else-if="!seconde.settleWorkerList">{{ seconde.billCostName}}</div>
              </template>
              <template v-if="seconde.billType == 1">
              <div class="item-name">{{ seconde.billCostName}}</div>
              </template>
              <div class="item-type" v-if="seconde.billType == 1">收</div>
              <div class="item-typezhi" v-if="seconde.billType == 2">支</div>
              <div class="item-Amount">{{ seconde.billAmount.toFixed(2) }}</div>
              <div class="item-remark">{{ seconde.remark || "/" }}</div>
              <div
                class="item-icon mar-20"
                @click="edit(seconde)"
              >
                <img src="@/assets/record/edit.png" alt="" />
              </div>
              <div class="item-icon" @click="del(seconde.no)">
                <img src="@/assets/record/delete.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <BaseEmptyData v-if="list.length == 0"></BaseEmptyData>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "@/api/apiIndividualRecord"
export default {
  name: "TeamRecord",
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    AddIncomeExpenses: () => import("@/views/TeamRecord/components/AddIncomeExpenses"),
    projectManagement: () => import("@/views/record/components/projectManagement"),
    WorkerManagement: () => import("@/views/record/components/worker-management/WorkerManagement"),
  },
  data() {
    return {
      year: "",
      yearoption: [],
      isshow: false,
      month: "",
      list: [],
      expenses: "", //总支出
      income: "", //总收入
      projectlist:[],//项目列表
      projectName:"",//项目名
      projectNo:"",//项目no
      page:{
        limit:100,
        page:1
      },
      type:this.$route.query.type?this.$route.query.type:1
    }
  },
  created() {
    this.getyeardata()
    this.getBillDetail()
    this.getprojectlist();
  },
  mounted(){
  },
  methods: {
    //获取项目列表
    async getprojectlist(){
      let res=await api.getProjectPage({...this.page,type:this.type});
      if(res.data.code==200){
        this.projectlist=res.data.data.records;
        let tempArr=this.projectlist.filter(v=>{ return v.defaultProject===0 })
        //获取默认项目名
        this.projectName=tempArr.length ? tempArr[0].projectName :this.projectlist.length? this.projectlist[0].projectName:''
        this.projectNo=tempArr.length ? tempArr[0].no :this.projectlist.length? this.projectlist[0].no:''
        if(this.projectNo) this.setDefault(this.projectNo)
        this.getBillDetail()
      }else{
        this.$message.error('系统异常,请稍后重试')
      }
    },
    //项目名下拉选择 
    getProjectName(no){
      this.projectNo=no
      this.projectName=this.projectlist.filter(v=>v.no==no)[0].projectName
      this.getBillDetail()
      this.setDefault(this.projectNo)
    },
    //设置默认项目接口
    async setDefault(no){
      await api.defaultProject({no})
    },
    //获取当前年月
    getyeardata() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      this.month = `0${month}`.substr(-2)
      let arr = []
      let i = year
      while (i >= 1970) {
        arr.push(i--)
      }
      this.year = year
      this.yearoption = arr
    },
    //改变月
    changemonth(index) {
      this.month = `0${++index}`.substr(-2)
      this.getBillDetail()
    },
    //改变年
    changeyear(val) {
      this.year = val
      this.isshow = false 
      this.getBillDetail()
    },
    //获取当前项目的列表详情
    async getBillDetail() {
      let params = {}
      params.monthDate = this.year + "-" + this.month
      params.settleProjectNo = this.projectNo
      params.type = "2"
      let { data } = await api.settleBillTeamList(params)
      if (data.code == 200) {
        this.list = data.data
      }
    },
    edit(row) {
      // 编辑收入/支出
      this.$refs.editincome[row.billType-1].open(row)
    },
    // 删除个人记账记录
    async del(no) {
      this.$message.tips("确定删除该条记账信息？", async v => {
        if (v) {
          let { data } = await api.deleteBill(no)
          if (data.code == 200) {
            this.getBillDetail()
          }
        }
      })
    },
    //获取图标
    getimg(type) {
      switch (type) {
        case "项目部用工":
          return require("@/assets/record/xmbyg.png")
        case "工程款":
          return require("@/assets/record/gongchengkuan.png")
        // case "奖金":
        //   return require("@/assets/record/jiangjin.png")
        // case "工资":
        //   return require("@/assets/record/gongzi.png")
        case "其他":
          return require("@/assets/record/qita.png")
        case "材料费":
          return require("@/assets/record/cailiao.png")
        case "工资发放":
          return require("@/assets/record/gongzifafang.png")
        case "生活用品":
          return require("@/assets/record/shenghuo.png")
        case "交通":
          return require("@/assets/record/jiaotong.png")
        case "医疗":
          return require("@/assets/record/yiliao.png")
        case "吃饭":
          return require("@/assets/record/chifan.png")
        case "娱乐":
          return require("@/assets/record/yule.png")
        case "住宿":
          return require("@/assets/record/zhusu.png")
      }
    },
      upNo(no){
      this.projectlist.forEach((v,i)=>{
        if(v.no==no){
          if(this.projectid!=i){
            this.projectid=i;
            this.getBillDetail();
          }
        }
      })
    },
  },
  computed: {
    // 总收入合计
    totalincome() {
      let money = null
      if (this.list.length > 0) {
        this.list.forEach(item => {
          money += item.income
        })
        return money
      } else {
        return 0
      }
    },
    //总支出合计
    totalexpenses() {
      let money = null
      if (this.list.length > 0) {
        this.list.forEach(item => {
          money += item.expenses
        })
        return money
      } else {
        return 0
      }
    }
  },
  filters: {
    getdate(val) {
      if (val) {
        return val.split("-")[2]
      }
    },
    getmonth(val) {
      if (val) {
        return val.split("-")[1]
      }
    },
    getyear(val) {
      if (val) {
        return val.split("-")[0]
      }
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-input__inner{
  height: 34px;
}
.page {
  box-sizing: border-box;
  margin: 10px auto;
  padding: 20px;
  width: 1200px;
  background: #fff;
  font-family: MicrosoftYaHei;
  .button {
    display: flex;
    height: 34px;
    align-items: center;
    margin-bottom: 20px;
    .totalmonth {
      // width: 230px;
      color: #333333;
      font-weight: bold;
      margin-right: 15px;
      .total {
        font-size: 18px;
        margin-right: 5px;
      }
      .totaltime {
        font-size: 14px;
      }
    }
    .line-right {
      flex: 1;
    }
    .totalmoney {
      font-size: 14px;
      color: #333333;
    }
    .totalincome {
      color: #e1251b;
      font-size: 16px;
    }
    .totalexpenses {
      color: #55b148;
      font-size: 16px;
      display: inline-block;
      // margin-right: 350px;
    }
    .line {
      width: 1px;
      height: 14px;
      background: #c0c4cc;
      margin: 0 10px 0 10px;
    }
  }
  .teamrecord {
    display: flex;
    .aside {
      width: 152px;
      position: relative;
      margin-right: 10px;
      border-bottom: 1px solid #e6e8ee;
      .yearselect {
        cursor: pointer;
        height: 44px;
        line-height: 44px;
        padding-left: 15px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        border: 1px solid #e6e8ee;
        span {
          display: inline-block;
        }
        .expand {
          margin-left: 61px;
          img {
            width: 10px;
            height: 6px;
          }
        }
      }
      .yearoption {
        position: absolute;
        top: 46px;
        left: 0px;
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
        height: 270px;
        overflow-y: scroll;
        .itemyear {
          padding-left: 15px;
          height: 44px;
          border: 1px solid #e6e8ee;
          color: #333333;
          background-color: #fafafa;
          line-height: 44px;
          border-top: unset;
          cursor: pointer;
        }
      }
      .month {
        height: 42px;
        line-height: 42px;
        background-color: #ffff;
        padding-left: 20px;
        font-size: 20px;
        border-right: 1px solid #e6e8ee;
        color: #c0c4cc;
        cursor: pointer;
      }
      .monthunit {
        font-size: 12px;
      }
      .month:hover {
        background-color: rgba(183, 146, 85, 0.1);
      }
      .selectedmonth {
        height: 42px;
        line-height: 42px;
        padding-left: 20px;
        color: #b79255;
        font-weight: bold;
        font-size: 20px;
        border-left: 4px solid #b79255;
        border-right: unset;
        border-top: 1px solid #e6e8ee;
        border-bottom: 1px solid #e6e8ee;
        box-sizing: border-box;
      }
    }
    .content {
      flex: 1;
      .content-nav {
        display: flex;
        align-items: center;
        height: 44px;
        background: #f5f7fa;
        color: #666666;
        font-size: 14px;
        .nav-time {
          margin-left: 20px;
          width: 208px;
        }
        .nav-income {
          width: 208px;
        }
        .nav-note {
          width: 260px;
        }
        .mar-20 {
          margin-left: 20px;
        }
      }
      .list-item {
        height: 508px;
        overflow-y: scroll;
        font-size: 14px;
        .item-title {
          height: 50px;
          line-height: 50px;
          padding-left: 20px;
          display: flex;
          border-bottom: 1px solid #e6e8ee;
          .title-date {
            width: 204px;
            .day {
              color: #000000;
              font-size: 16px;
              font-weight: bold;
            }
            .title-time {
              color: #c0c4cc;
              font-size: 14px;
            }
          }
          .title-income {
            width: 230px;
            color: #e1251b;
            font-size: 16px;
          }
          .title-expenses {
            color: #55b148;
            font-size: 16px;
          }
        }
        .item-content {
          background-color: #f5f5f5;
          border-bottom: 1px solid #e6e8ee;
          padding-left: 90px;
          height: 45px;
          display: flex;
          align-items: center;
          .item-img {
            img {
              width: 20px;
              height: 20px;
              vertical-align: middle;
            }
            line-height: 45px;
          }
          .item-name {
            width: 220px;
            font-size: 14px;
            // line-height: 45px;
            display: inline-block;
            margin-left: 8px;
          }
          .item-type {
            width: 20px;
            margin-right: 10px;
            line-height: 45px;
            color: #e1251b;
          }
          .item-typezhi {
            width: 20px;
            margin-right: 10px;
            line-height: 45px;
            color: #55b148;
          }
          .item-Amount {
            width: 297px;
            text-align: left;
            display: inline-block;
            line-height: 45px;
          }
          .item-remark {
            width: 184px;
            font-size: 12px;
            display: inline-block;
            margin-right: 70px;
            color: #666666;
            word-wrap: break-word;
          }
          .item-icon {
            width: 14px;
            cursor: pointer;
            img {
              width: 14px;
              height: 14px;
            }
          }
          .mar-20 {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
// 取消纵向滚动条
::-webkit-scrollbar {
  display: none;
}
</style>
<!--
 appendbody的弹窗只能全局改样式
-->
<style lang="scss">
.el-dialog.editindividualrecord {
  .el-dialog__header {
    padding: 15px 20px;
  }

  .el-dialog__body {
    border-top: 1px solid #e4e7ed;
  }

  .el-button--default {
    color: #969696;
    background: #fff;
    border-color: #e4e7ed !important;

    // &:hover {
    //   color: #b79255 !important;
    //   background: #fff;
    //   border-color: #b79255 !important;
    // }
  }

  .el-button--primary {
    background: #b79255 !important;
    border-color: #b79255 !important;
  }
}
</style>